import { render, staticRenderFns } from "./CleanupComponent.vue?vue&type=template&id=39b09f48&scoped=true&"
import script from "./CleanupComponent.vue?vue&type=script&lang=js&"
export * from "./CleanupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b09f48",
  null
  
)

export default component.exports